import type { Variant, Product } from '../services/schemas';

export function isProductTypeLocked(
  typeVariants: Variant[],
  allVariants: Variant[],
  products: Product[]
): boolean {
  return typeVariants[0].productType.dependencies.some((depVariantId) => {
    const depVariant = allVariants.find((v) => v.id === depVariantId);
    if (!depVariant) return true;
    const depTypeName = depVariant.productType.name;
    const depTypeVariantIds = allVariants
      .filter((v) => v.productType.name === depTypeName)
      .map((v) => v.id);
    return !products.some((p) => depTypeVariantIds.includes(p.variant));
  });
}
